import React from 'react';
import { Trans } from 'react-i18next';
import { ConfirmationModal } from '~/Components';
import { useLanguage, useProvider } from '~/Hooks';
import { IChecklistCreatedPartnerDetail } from '~/Models/DTO/CheckList.model';
import { Typography } from '~/UIKit';

interface IChecklistRequestApprovalProps {
  checklist: IChecklistCreatedPartnerDetail;
  updateChecklist: (checklist: Partial<IChecklistCreatedPartnerDetail>) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}

export const ChecklistRequestApproval = ({
  checklist,
  updateChecklist,
  isModalOpen,
  setIsModalOpen,
}: IChecklistRequestApprovalProps) => {
  const { t } = useLanguage();
  const { currentProvider } = useProvider();
  const isReadyForApproval = checklist?.eventCreated && checklist?.studioDataEdited;
  const onCancel = () => {
    setIsModalOpen(false);
  };
  const onConfirm = () => {
    updateChecklist({ approvalRequested: new Date().toISOString() });
    setIsModalOpen(false);
  };
  return (
    <ConfirmationModal
      open={isModalOpen}
      title={t('checklist.partnerPortalCreated.approvalRequested.title')}
      cancel={{ action: onCancel }}
      confirm={{
        title: t('checklist.partnerPortalCreated.approvalRequested.title'),
        action: onConfirm,
        hidden: !isReadyForApproval,
      }}
    >
      <Typography variant="body1">
        {isReadyForApproval ? (
          <Trans
            i18nKey="checklist.partnerPortalCreated.approvalRequested.description"
            values={{ studioName: currentProvider?.name }}
            components={{ break: <br /> }}
          />
        ) : (
          t('checklist.partnerPortalCreated.approvalRequested.notReady')
        )}
      </Typography>
    </ConfirmationModal>
  );
};
